'use strict';

import React, { Component, Fragment } from 'react'

import { v4 as uniqid } from 'uuid'
import _      from 'lodash'

import { search } from '@root/utility'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'
import FloatingCard    from '@/FloatingCard'
import Pagination      from '@/Pagination'
import Slider          from '@/Slider'
import UserCard        from '@/UserCard'

import PartnersMap from '@/Maps/PartnersMap'

import SearchBar from '@Pure/SearchBar'
import Loader    from '@Pure/Loader'
import Image     from '@Pure/Image'
import Link      from '@Pure/Link'
import Logo      from '@Pure/Logo'

import bemit from '@function/bemit'

const { app, qwest, moment } = window;

export default class FrontPartnersPage extends Component
{
	state =
	{
		data: [],
		references: [],
		highlighted_partners: [],

		width: window.innerWidth,
		render_id: uniqid(),

		slider_ready: false,

		pagination:
		{
			max_items: 5 * 4,
			limit: 5 * 4,
			skip: 0
		},

		searched:
		{
			value: ''
		}
	};

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, config = this.props.config;

		app.resetFunctions();

		component.setState({ loading: true, searched_category: 'all' });

		qwest.post('/data/partners-page').then(function (xhr, response)
		{
			let data = response.partners;

			data.filter(partner => Boolean(partner.place))
			.forEach(function (partner)
			{
				let place = (response.references
				.find(infos => infos.model === 'place') || { data: [] })
				.data.find(place => place.id === partner.place);

				if (place)
				{
					partner._place = place.name;
				}
			});

			data.filter(partner => Boolean(partner.category))
			.forEach(function (partner)
			{
				let category = (response.references
				.find(infos => infos.model === 'category') || { data: [] })
				.data.find(category => category.id === partner.category);

				if (category)
				{
					partner._category = category;
				}
			});

			component.setState(
			{
				loading: false,

				data: data,

				highlighted_partners: data
				.filter(partner => [true, 'true'].includes(partner.highlighted))
				.sort(function (a, b)
				{
					if (!a.updatedAt && !b.updatedAt) return 0;
					if (!a.updatedAt) return 1;
					if (!b.updatedAt) return -1;

					const a_date = moment(a.updatedAt).format();
					const b_date = moment(b.updatedAt).format();

					return a_date === b_date
					? 0
					: moment(a_date).isBefore(b_date) ? 1 : -1;
				}),

				geocodings: response.geocodings
				.map((data, id) => _.merge({ id: id }, data)),

				references: response.references || []
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(error, xhr, response);

			app.ajaxRedirectLogin(response);
		});

		app.push(
		{
			event: 'window.resize',
			cb: component.handleResize
		});

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		if (app.state.session?.id) component.handleSessionChange();
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'window.resize',
			cb: component.handleResize
		});

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange = () =>
	{
		const component = this, props = this.props, state = this.state;

		const permissions = app.state.session.permissions || { title: 'not_auth' };

		component.setState({ permissions: permissions });
	}

	handleResize = ({ source }) =>
	{
		const component = this, props = this.props, state = this.state;

		if (window.innerWidth !== state.width)
		{
			component.setState({ width: window.innerWidth, render_id: uniqid() });
		}
	}

	setPagination = (e, page) =>
	{
		const component = this, props = this.props, state = this.state;

		const { max_items } = state.pagination;

		component.setState(
		{
			pagination:
			{
				...state.pagination,

				limit: (page+1) * max_items,
				skip: page * max_items
			}
		});
	}

	handleSearch = (value, search) =>
	{
		const component = this, props = this.props;

		component.setState(
		{
			searched:
			{
				value: value,
				data: (search ? search.data : undefined)
			}
		});

		app.emit('searchChange');
	}

	handleCategoryChange = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		let searched_category = e.target.value;

		if (Array.isArray(state.geocodings))
		{
			state.geocodings = state.geocodings.map(function (geocoding)
			{
				if (Array.isArray(geocoding.partners) === false) return geocoding;

				if (searched_category === '' || searched_category === 'all')
				{
					geocoding.visible = true;

					return geocoding;
				}

				let has_category = geocoding.partners.find(function (partner)
				{
					return partner.category === searched_category;
				});

				if (has_category)
				{
					geocoding.visible = true;
				}
				else
				{
					geocoding.visible = false;
				}

				return geocoding;
			});
		}

		component.setState(
		{
			searched_category: searched_category,
			geocodings: state.geocodings
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let loader;

		if (component.state.loading === true)
		{
			loader =
			(
				<Loader className="c-loader"
					bemit={ ['primary', 'bg-light', 'medium', 'Products'] } />
			);
		}

		const slider_loader = state.loading === true || !state.slider_ready ?
		(
			<Loader className="c-loader"
				bemit={ ['primary', 'bg-light', 'medium', 'Products'] }
			/>
		)
		: undefined;

		let slides = [], i = 0;

		const per_slide = state.width >= 1399 ? 5 * 2
		: state.width >= 1024 ? 4 * 2
		: state.width > 768 ? 3 * 2
		: state.width > 550 ? 2 * 2
		: 1 * 2;

		state.highlighted_partners.forEach(function (partner)
		{
			let active = slides[i], thumbnail;

			if (!active || active.content.length >= per_slide)
			{
				if (active && active.content.length >= per_slide)
				{
					i++;
				}

				slides.push(
				{
					id: partner.id,

					content: []
				});
			}

			const url = '/accueil/espace-partenaires/partenaires/' + partner.id;
		/**
		 * Get thumbnail to be displayed (logo > images > default image)
		**/
			if (Array.isArray(partner.logo) && partner.logo[0]) // logo
			{
				thumbnail =
				(
					<Image className="c-model-preview__img"
						src={ partner.logo[0].url }
					/>
				);
			}
			else if (Array.isArray(partner.images) && partner.images[0])
			{
				thumbnail =
				(
					<Image className="c-model-preview__img"
						src={ partner.images[0].url }
					/>
				);
			}
			else // default image
			{
				thumbnail =
				(
					<Logo className="c-model-preview__img default"
						type="svg" synergies={ true }
					/>
				);
			}

			let short_description = partner.discount_infos.split('<br>').join('');

			short_description = short_description.split('<p></p>').join('');

			short_description =
			(
				<span className="c-rendered-text" dangerouslySetInnerHTML={
					{ __html: app.truncateToLength(short_description, 130, '') } }
				/>
			);

			let place;

			if (partner._place)
			{
				place =
				(
					<Link className="c-model-preview__places" href={ url }>
						<svg className="o-svg-icon o-svg-icon--tracker c-model-preview__places-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-tracker"></use>
						</svg>
						{ partner._place }
					</Link>
				);
			}
			else if (partner.city)
			{
				place =
				(
					<Link className="c-model-preview__places" href={ url }>
						<svg className="o-svg-icon o-svg-icon--tracker c-model-preview__places-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-tracker"></use>
						</svg>
						{ partner.city }
					</Link>
				);
			}

			let output =
			(
				<div className={ bemit('c-model-preview', ['highlighted-partners']) }
					key={ partner.id }>

					<div className="c-model-preview__thumb">
						<Link className="c-model-preview__thumb-link"
							href={ url }>
							{ thumbnail }
						</Link>
					</div>

					<h2 className="c-model-preview__title">
						<Link className="c-model-preview__title-link"
							href={ url }>
							{ partner.name }
						</Link>
					</h2>

					<div className="c-model-preview__infos">

						<div className="c-model-preview__description">
							{ short_description }

							<Link className="u-link-only"
								href={ url }
							/>
						</div>

						{ place }

					</div>

				</div>
			);

			slides[i].content.push(output);
		});

		slides = slides.map(function (slide)
		{
			let i = 0;

			const content = (slide.content || []).slice(0);

			while (content.length < per_slide)
			{
				const placeholder =
				(
					<div className={ bemit('c-model-preview',
						['highlighted-partners']) } key={ i }
					/>
				);

				i += 1;

				content.push(placeholder);
			}

			const data =
			{
				id: slide.id,

				content:
				(
					<div className="o-img-slider__content-row">
						{ content }
					</div>
				)
			};

			return data;
		});

		let data = state.data;

		if (component.state.searched.value?.length > 2)
		{
			data = data.filter(function (partner)
			{
				let matches = 0;

				['discount_infos', 'informations', 'name', '_place', 'city']
				.forEach(function (field)
				{
					if (!partner[field]) return;

					matches += search(partner[field], component.state.searched.value);
				});

				partner.__search_matches = matches;

				return matches > 0;
			})
			.sort(function (a, b)
			{
				return a.__search_matches > b.__search_matches;
			});
		}
		else
		{
			data = data
			.sort(function (a, b)
			{
				return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
			});
		}

		if (component.state.searched_category !== 'all')
		{
			data = data.filter(function (product)
			{
				if (!product._category) return false;

				if (product._category.id === component.state.searched_category)
				{
					return true;
				}

				return false;
			});
		}
		else if (!state.searched.value || state.searched.value.length <= 2)
		{
			data = data
			.filter(function (element, index)
			{
				if (props.pagination === false)
				{
					return true;
				}

				return index < state.pagination.limit && index >= state.pagination.skip;
			})
		}

		let partners = data.map(function (partner, key)
		{
			let category, place;

			if (partner._category)
			{
				category =
				(
					<div className="c-model-preview__themes">
						<div className="c-model-preview__theme">
							{ partner._category.name }
						</div>
					</div>
				);
			}

			const url = '/accueil/espace-partenaires/partenaires/' + partner.id;

			if (partner._place)
			{
				place =
				(
					<Link className="c-model-preview__places" url={ url }>
						<svg className="o-svg-icon o-svg-icon--tracker c-model-preview__places-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-tracker"></use>
						</svg>
						{ partner._place }
					</Link>
				);
			}
			else if (partner.city)
			{
				place =
				(
					<Link className="c-model-preview__places" url={ url }>
						<svg className="o-svg-icon o-svg-icon--tracker c-model-preview__places-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-tracker"></use>
						</svg>
						{ partner.city }
					</Link>
				);
			}

			let short_description = partner.discount_infos.split('<br>').join('');
			short_description = short_description.split('<p></p>').join('');

			short_description =
			(
				<span className="c-rendered-text" dangerouslySetInnerHTML={
					{ __html: app.truncateToLength(short_description, 130, '') } }
				/>
			);

			let thumbnail;

			if (partner.logo && partner.logo[0])
			{
				thumbnail = partner.logo[0].url;
			}
			else if (partner.images && partner.images[0])
			{
				thumbnail = partner.images[0].url;
			}

			if (thumbnail)
			{
				thumbnail =
				(
					<Image className="c-model-preview__img" src={ thumbnail } />
				);
			}
			else
			{
				thumbnail =
				(
					<Logo className="c-model-preview__img default" type="svg"
						synergies={ true } />
				);
			}

			let displayed_name = partner.name;

			if (partner.city)
			{
				displayed_name += ' (' + partner.city + ')';
			}

			let output =
			(
				<div className="c-model-preview-item partner o-grid__item u-flex"
					key={ partner.id }>

					<div className="c-model-preview c-model-preview--partner">
						<div className="c-model-preview__thumb">
							<Link className="c-model-preview__thumb-link"
								href={ url }>
								{ thumbnail }
							</Link>
						</div>

						<h2 className="c-model-preview__title">
							<Link href={ url }
								className="c-model-preview__title-link">
								{ displayed_name }
							</Link>
						</h2>

						{ category }

						<div className="c-model-preview__infos">

							<div className="c-model-preview__description">
								{ short_description }
							</div>

							{ place }

							<div className="c-model-preview__buttons">
								<Link href={ url }
									className="c-model-preview__link">
									<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
										<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
									</svg>Fiche partenaire
								</Link>
							</div>

						</div>
					</div>

				</div>
			);

			return output;
		});

		const hide_pagination =
		[
			state.data.length < state.pagination.max_items,
			state.searched_category !== 'all',
			state.searched.value && state.searched.value.length > 2
		]
		.some(condition => condition);

		const { skip, max_items } = state.pagination;

		const total_items = (state.data || []).length;

		const pagination = hide_pagination ? undefined :
		(
			<Pagination current={ !skip ? 0 : skip/max_items }
				total={ total_items }
				items-per-page={ max_items }
				onChange={ component.setPagination }
			/>
		);

		let categories = (component.state.references
		.find(infos => infos.model === 'category') || { data: [] })
		.data
		.sort(function (a, b)
		{
			return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
		})
		.map(function (category)
		{
			let output =
			(
				<option value={ category.id } key={ category.id || '-1' }>
					{ category.name }
				</option>
			);

			return output;
		});

		const map = Array.isArray(state.geocodings) ?
		(
			<PartnersMap geocodings={ state.geocodings } />
		)
		: undefined;

		let partners_slider = state.loading ? slider_loader : slides.length > 0 ?
		(
			<div className="highlighted_partners_slider">

				<Slider key={ state.render_id } type="custom" elements={ slides }
					bemit={ ['highlighted-partners', 'multiple'] }
					hide-progress onReady={ () => component.setState({ slider_ready: true }) }
				/>

				{ !state.loading ? slider_loader : undefined }

			</div>
		)
		: undefined;

		partners_slider = partners_slider ?
		(
			<Fragment>

				<div className="c-title u-no-margin-top">
					<h2 className="c-title__txt">Partenaires du moment</h2>
				</div>

				{ partners_slider }

			</Fragment>
		)
		: undefined;

		var output =
		(
			<Layout history={ props.history } page_title="Partenaires">

				<div className="page-content">

					<HolidaysMessage />

					{
						['Membre de CE', 'Administrateur de CE']
						.includes(state.permissions?.title) ?
						(
							<div className="u-full-width u-text-center">
								<UserCard />
							</div>
						)
						: undefined
					}

					<div className="o-content">

						{ partners_slider }

						{ map }

						<div className="c-title u-no-margin-top">
							<h2 className="c-title__txt">Tous les partenaires Synergies</h2>
						</div>

						<div className="front-dashboard-search">
							<SearchBar className="c-searchbar c-searchbar--front"
								hide_btn={ true } placeholder="Rechercher dans les partenaires"
								data={ [] } handleChange={ component.handleSearch }
								value={ component.state.searched.value }
							/>

							<div className="front-dashboard-search__theme-label">
								Catégorie
							</div>

							<select className="c-form__input front-dashboard-search__theme"
								name="page-search-category"
								onChange={ component.handleCategoryChange }
								value={ component.state.searched.category }
								id={ (props.id_prefix || '') + component.state.id }>
								<option value="all">Tous</option>
								{ categories }
							</select>
						</div>

						<div className="c-pagination u-margin-bottom-15">
							{ pagination }
						</div>

						<div className="u-negative-margin">

							<div className="o-grid-4 u-flex">
								{ loader || partners }
							</div>

						</div>

						<div className="c-pagination u-margin-top-15">
							{ pagination }
						</div>

					</div>

				</div> { /* /page-content */ }

				<FloatingCard />

			</Layout>
		);

		return output;
	}
}